module.exports = __webpack_public_path__ + "img/cardbg.6e11b81b.svg";